import _Object$getOwnPropertyDescriptor from 'babel-runtime/core-js/object/get-own-property-descriptor';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

import { Event, Interface } from '@central-products/transport-bus-common';

var INavigationMenu = (_dec = Interface('myAccount', 'navigationMenu'), _dec2 = Event('select.myBets'), _dec3 = Event('select.reversalWithdraw'), _dec4 = Event('select.withdraw'), _dec5 = Event('select.withdrawAccountVerification'), _dec6 = Event('select.rewards'), _dec7 = Event('select.gamblingControls'), _dec8 = Event('select.pokerBalanceTransfer'), _dec(_class = (_class2 = function () {
  function INavigationMenu() {
    _classCallCheck(this, INavigationMenu);
  }

  _createClass(INavigationMenu, [{
    key: 'onMyBetsRequested',
    value: function onMyBetsRequested(callback) {
      throw new Error('Event is not implemented yet');
    }
  }, {
    key: 'onReversalWithdrawRequested',
    value: function onReversalWithdrawRequested(callback) {
      throw new Error('Event is not implemented yet');
    }
  }, {
    key: 'onWithdrawRequested',
    value: function onWithdrawRequested(callback) {
      throw new Error('Event is not implemented yet');
    }
  }, {
    key: 'onWithdrawAccountVerificationRequested',
    value: function onWithdrawAccountVerificationRequested(callback) {
      throw new Error('Event is not implemented yet');
    }
  }, {
    key: 'onRewardsRequested',
    value: function onRewardsRequested(callback) {
      throw new Error('Event is not implemented yet');
    }
  }, {
    key: 'onGamblingControlsRequested',
    value: function onGamblingControlsRequested(callback) {
      throw new Error('Event is not implemented yet');
    }
  }, {
    key: 'onPokerBalanceTransferRequested',
    value: function onPokerBalanceTransferRequested(callback) {
      throw new Error('Event is not implemented yet');
    }
  }]);

  return INavigationMenu;
}(), (_applyDecoratedDescriptor(_class2.prototype, 'onMyBetsRequested', [_dec2], _Object$getOwnPropertyDescriptor(_class2.prototype, 'onMyBetsRequested'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onReversalWithdrawRequested', [_dec3], _Object$getOwnPropertyDescriptor(_class2.prototype, 'onReversalWithdrawRequested'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onWithdrawRequested', [_dec4], _Object$getOwnPropertyDescriptor(_class2.prototype, 'onWithdrawRequested'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onWithdrawAccountVerificationRequested', [_dec5], _Object$getOwnPropertyDescriptor(_class2.prototype, 'onWithdrawAccountVerificationRequested'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRewardsRequested', [_dec6], _Object$getOwnPropertyDescriptor(_class2.prototype, 'onRewardsRequested'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onGamblingControlsRequested', [_dec7], _Object$getOwnPropertyDescriptor(_class2.prototype, 'onGamblingControlsRequested'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onPokerBalanceTransferRequested', [_dec8], _Object$getOwnPropertyDescriptor(_class2.prototype, 'onPokerBalanceTransferRequested'), _class2.prototype)), _class2)) || _class);


export default INavigationMenu;